import React from "react"
import Pill from "@irati/ui/src/Pill"
import styled from "styled-components"
import {FlexiPointMigrationStatus, useFlexiMigration} from "@irati/wallet/hooks/flexiMigration"
import {useIntl} from "@irati/utils/lang"
import {walletTracking} from "@irati-tracking/wallet"

const StyledPill = styled(Pill)<{migrationStatus: FlexiPointMigrationStatus}>`
  gap: ${({theme}) => theme.spacing.one};
  flex-direction: row-reverse;
  width: 100%;

  ${({theme, migrationStatus}) => {
    switch (migrationStatus) {
      case "POST":
        return `background: linear-gradient(241deg, ${theme.colors.secondary1} 0%, ${theme.colors.primary2} 100%);`
      case "MID":
        return `background: ${theme.colors.tertiary.o_400}`
      case "PRE":
      default:
        return `background: linear-gradient(61deg, ${theme.colors.primary2} 0%, ${theme.colors.primary1} 100%);`
    }
  }}
`

const messages = {
  PRE: "wallet.pointsConversion.adminPill.pre",
  MID: "wallet.pointsConversion.adminPill.mid",
  POST: "wallet.pointsConversion.adminPill.post"
}

interface Props {
  full?: boolean
}
export function PillPointsConversion({full}: Props) {
  const {formatMessage} = useIntl()
  const {status} = useFlexiMigration()
  if (!status) return null

  return (
    <div style={{width: full ? "100%" : "auto"}}>
      <a
        onClick={(e) => {
          walletTracking.clickPointsSimplifcationLearnMore({source: "admin_hub"})
          e.stopPropagation()
        }}
        rel="noreferrer"
        href={formatMessage({id: "wallet.pointsConversion.learnAdminLink"})}
        target="_blank">
        <StyledPill migrationStatus={status} text={formatMessage({id: messages[status]})} inline iconType="info" isWhiteText />
      </a>
    </div>
  )
}
